import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import { ROUTES } from '@/constants';
import { getPostLoginRoute } from '@/features/auth/utils/getPostLoginRoute';

/**
 * Guest guard — redirects authenticated users away from auth pages.
 * Prevents logged-in users from seeing login/register.
 */
export function GuestGuard({ children }) {
    const { isAuthenticated, isLoading, user } = useAuthContext();

    if (isLoading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to={getPostLoginRoute(user)} replace />;
    }

    return children;
}

export default GuestGuard;
